import { render, staticRenderFns } from "./sela_concept_detail.vue?vue&type=template&id=871d9a96&scoped=true"
import script from "./sela_concept_detail.vue?vue&type=script&lang=js"
export * from "./sela_concept_detail.vue?vue&type=script&lang=js"
import style0 from "./sela_concept_detail.vue?vue&type=style&index=0&id=871d9a96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871d9a96",
  null
  
)

export default component.exports